/**
 * ChatActionsContext · 把 useAIClassifySession 的 API 下发给 Composer 等深层组件
 *
 * 父级（AIClassifyPage）调用 useAIClassifySession() 拿到 { sendUserMessage }，
 * 通过 Provider 注入；Composer 用 useChatActions() 消费。
 *
 * 这样 hook 在树上只跑一次（避免每个组件各订阅消息变化重复触发副作用）。
 */

import React, { createContext, useContext } from 'react'

export interface ChatActions {
  sendUserMessage: (text: string) => void
  /**
   * 重新发起某条 user 消息所在的回合 · MessageText hover 刷新按钮调用
   *  · 截断从该消息起的所有消息（含其后 AI 回复）
   *  · 用同样文案再 sendUserMessage 触发新一轮 SSE
   */
  regenerateFromUserMessage: (messageId: string, text: string) => void
  /** 开新对话 · 抽屉头部按钮调用 */
  startNewConversation: () => void
  /** 切到历史会话 · 历史会话列表点击调用 */
  switchConversation: (targetConvId: string) => void
}

const ChatActionsContext = createContext<ChatActions | null>(null)

export const ChatActionsProvider = ChatActionsContext.Provider

export function useChatActions(): ChatActions {
  const ctx = useContext(ChatActionsContext)
  if (!ctx) {
    throw new Error(
      '<ChatActionsProvider> 未注入；请在 AIClassifyPage 顶层包裹。'
    )
  }
  return ctx
}
